import type { ReactNode } from 'react';

export interface LwTableToolbarProps {
  label?: string;
  primary?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function LwTableToolbar({
  label = 'Table controls',
  primary,
  actions,
  className
}: LwTableToolbarProps) {
  return (
    <div className={`lw-table-toolbar${className ? ` ${className}` : ''}`} role="group" aria-label={label}>
      {primary && <div className="lw-table-toolbar__primary">{primary}</div>}
      {actions && <div className="lw-table-toolbar__actions">{actions}</div>}
    </div>
  );
}
